var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-count-card",on:{"click":function($event){return _vm.$emit('troggleTab', _vm.item.key)}}},[_c('div',{staticClass:"decoration",style:({ background: _vm.color })}),_c('div',{staticClass:"main-container"},[_c('hypervisor-unit-icon',{style:({
        color: _vm.color,
        fontSize: '48px',
        paddingRight: '40px'
      }),attrs:{"icon":_vm.item.key}}),_c('div',{staticStyle:{"padding-right":"40px"}},[_c('p',{staticClass:"card-value",style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.item.value))]),_c('p',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.item.name))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }